<template>
  <div class="page-wrapper">
    <router-view></router-view>
  </div>
</template>
